import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type SvgIconComponent } from "@mui/icons-material";

/**
 * R.E.ASSIST のマーク（ビルの図案）だけの版。reassist_logo.svg のマーク部分と同じ path と色を使う。
 * path に fill を指定しているため、sx の color を渡しても色は変わらない。
 * アイコンの位置（サイドバーの折りたたみ時、マイページのカテゴリ見出し）に使い、文字入りのロゴを縮めて押し込まない。
 */
const ReassistMark: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="270 322 76 76" {...props}>
    <path
      fill="rgb(16.078186%, 50.196838%, 44.7052%)"
      d="M 310.96875 328.296875 L 308.84375 327.304688 L 308.550781 327.433594 L 299.375 331.714844 L 297.003906 332.820312 L 293.996094 334.222656 L 293.996094 355.019531 L 294.003906 355.019531 L 297.003906 356.417969 L 299.375 357.527344 L 299.375 387.707031 L 308.550781 391.984375 L 308.550781 345.480469 L 306.097656 343.734375 L 308.550781 342.589844 L 310.96875 341.464844 L 324.164062 335.3125 L 324.164062 334.449219 Z M 310.96875 328.296875"
    />
    <path
      fill="rgb(77.6474%, 76.863098%, 76.863098%)"
      d="M 324.164062 340.953125 L 324.164062 386.542969 L 310.96875 392.695312 L 310.96875 347.105469 Z M 324.164062 340.953125"
    />
    <path
      fill="rgb(52.157593%, 74.510193%, 69.020081%)"
      d="M 342.164062 369.386719 L 342.164062 390.375 L 326.535156 386.1875 L 326.535156 366.496094 L 331.277344 364.289062 L 333.511719 363.242188 L 342.054688 369.3125 Z M 342.164062 369.386719"
    />
    <path
      fill="rgb(52.157593%, 74.510193%, 69.020081%)"
      d="M 297.003906 358.972656 L 297.003906 380.261719 L 293.996094 381.664062 L 293.996094 385.851562 L 273.53125 391.222656 L 273.53125 358.917969 L 285.207031 353.476562 L 291.257812 356.292969 L 293.996094 357.574219 Z M 297.003906 358.972656"
    />
  </SvgIcon>
);

/** MUI のアイコンと同じ型で渡せるようにする（CategoryContainer、サイドバーの icon）。 */
export const ReassistMarkIcon = Object.assign(ReassistMark, {
  muiName: "SvgIcon",
}) as unknown as SvgIconComponent;
